import React, { Component } from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';
import { I as InfoIcon } from '../InfoIcon-f1b0281a.js';
import Toggle from './Toggle.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../Icons/InfoIcon.js';
import 'classnames';

var css_248z = ".IHGq-{display:flex}[dir] .IHGq- * p{margin:0}.IHGq-{gap:36px}[dir] .IHGq-{padding-top:24px}@media only screen and (max-width:640px){[dir] .IHGq-+.IHGq-{padding-top:36px}}.RyWzw{height:100%;width:100%}[dir] .RyWzw{margin:0}.oWl2C{fill:var(--ricos-settings-icons-color,#000);color:var(--ricos-settings-icons-color,#000)}[dir] .oWl2C{cursor:pointer}[dir=ltr] .oWl2C{margin-left:4px}[dir=rtl] .oWl2C{margin-right:4px}.AJvRC{align-items:center;display:flex;flex-direction:row;justify-content:center}.wG43b{color:var(--ricos-settings-text-color,#000);font-size:16px}[dir=ltr] .wG43b{text-align:left}[dir=rtl] .wG43b{text-align:right}@media only screen and (max-width:640px){.wG43b{font-size:14px}}";
var styles = {"labeled_toggle_root":"IHGq-","labeled_toggle_checkbox_input":"RyWzw","infoIcon":"oWl2C","labeled_toggle_label_wrapper":"AJvRC","labeled_toggle_label":"wG43b"};
styleInject(css_248z);

class LabeledToggle extends Component {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { label, onChange, checked, style, dataHook, tooltipText, isMobile = false } = this.props;
    return /* @__PURE__ */ React.createElement("div", { className: this.styles.labeled_toggle_root, style }, /* @__PURE__ */ React.createElement("div", { className: this.styles.labeled_toggle_label_wrapper }, /* @__PURE__ */ React.createElement(
      "div",
      {
        role: "button",
        tabIndex: 0,
        onClick: onChange,
        onKeyPress: (e) => e.key === "Enter" && onChange()
      },
      /* @__PURE__ */ React.createElement("p", { className: this.styles.labeled_toggle_label }, label)
    ), tooltipText && !isMobile && /* @__PURE__ */ React.createElement(InfoIcon, { iconStyles: styles.infoIcon, tooltipText })), /* @__PURE__ */ React.createElement(Toggle, { checked, onChange, dataHook }));
  }
}

export { LabeledToggle as default };
//# sourceMappingURL=LabeledToggle.js.map
